
<div class="card" *ngIf="!loading">
    <div class="card-header">
        <h3 class="text-center"> Awards & Gifts For Your Learners</h3>
    </div>
    <div class="card-body">

<div class="table-responsive" *ngIf="guardian.students.length>0">
    <table datatable [dtOptions]="dtOptions" class="table table-striped display compact" id="assetTable">
        <tr><td>Name</td><td> Awards & Gifts</td></tr>
<tr *ngFor="let student of guardian.students; index as myCount">
   <td><i class="fa fa-graduation-cap"></i> {{student.fullname}}</td>
   <td> <a [routerLink]="['/award/student/',student.server_user_id]"><i class="fa fa-trophy"></i> </a></td>
</tr>
</table>
</div>
<div *ngIf="guardian.students.length<=0" class="alert alert-info">
Shows awards and gifts for your students. A gift is acquired when  16 questions are passed. Awards are given
after a given accomplishment such as getting 100% consecutive times in 5 quizes.
</div>
</div>
</div>
<app-spinner *ngIf="loading"> </app-spinner>
